import React from 'react';

import { getProductDisplayName } from '../../constants';

import './index.scss';

const LeftPanel = ({ sitesData }) => {
  const orderId = sitesData.orderId;
  const product = sitesData.product;
  const accountName = sitesData.accountName;

  return (
    <div className="leftpanel-container">
      <div className="box">
        <div className="title">Order ID</div>
        <div className="value">{orderId || '-'}</div>
      </div>

      <div className="box">
        <div className="title">Product</div>
        {/* <div className="value">{getProductDisplayName(product) || '-'}</div> */}
        <div className="value">{product || '-'}</div>
      </div>

      <div className="box">
        <div className="title">Account Name</div>
        <div className="value">{accountName || '-'}</div>
      </div>

      <div className="box">
        <div className="title">Company Project Manager</div>
        <div className="sub_value bold">{(sitesData.cpmFirstName || '-') + ' ' + (sitesData.cpmLastName || '-')}</div>
        <div className="sub_value light">{sitesData.cpmPhoneNumber || '-'}</div>
        <div className="sub_value light">{sitesData.cpmEmail || '-'}</div>
      </div>

      {/* <div className="box">
        <div className="title">Project Manager</div>
        <div className="sub_value bold">{(sitesData.pmFirstName || '-') + ' ' + (sitesData.pmLastName || '-')}</div>
        <div className="sub_value light">{sitesData.pmPhoneNumber || '-'}</div>
        <div className="sub_value light">{sitesData.pmEmail || '-'}</div>
      </div> */}

      <div className="box">
        <div className="title">Site Readiness Checklist</div>
        <div className="info_section">
          <div className="content">
            <div className="content_title">For smooth & fast installation, please ensure:</div>
            <div className="item_title">Server room is ready with:</div>
            <ul className="requirement_details">
              <li>Space & rack for server setup</li>
              <li>Proper Voltage (220V – 240V) with Earthing (0.1V - 2V)</li>
              <li>Uninterrupted power supply (UPS)</li>
            </ul>
            <div className="item_title">Permission available for:</div>
            <ul className="requirement_details">
              <li>Pole or tower Installation with access to rooftop (only for wireless)</li>
              <li>In-building wiring</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeftPanel;
